import CategoryFilter from "./blog/CategoryFilter";
export default class BlogPage {
    constructor() {
        this.blog = document.querySelector('.blog');
        if (this.blog) {
            new CategoryFilter();
        }
    }
}
